<template>
  <v-sheet @mouseleave="subMenuDrawer2 = false; subMenuDrawer = false">
     <v-navigation-drawer
      v-model="subMenuDrawer2"
      fixed
      left
      temporary
      style="margin-left: 370px; z-index: 6"
    >
    
    <v-list>
      <v-list-item-content>
        <h3 class="d-flex justify-start ma-4" v-text="itemsSubMenu2.text"></h3>
      </v-list-item-content>
      <span  v-for="item in itemsSubMenu2.children"
          :key="item.name">
      <v-list-item
          name="item.name"
          link
          @click="openSubmenu(item); "
          class="menu-btn"
          v-if="item.meta.isMenuItem && hasPermission(item.meta)"
        >
        <v-list-item-content >
          
          <v-list-item-title v-if="!mini" class="menu-btn-label d-flex"><!-- justify-start" -->{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </span>
    </v-list>
     </v-navigation-drawer>
      <v-navigation-drawer
      v-model="subMenuDrawer"
      fixed
      left
      temporary
      style="margin-left: 120px; z-index: 6"
    >
    <v-list>
      <v-list-item-content>
        <h3 class="d-flex justify-start ma-4" v-text="itemsSubMenu.text"></h3>
      </v-list-item-content>
      <span  v-for="item in itemsSubMenu.children"
          :key="item.name">
      <template v-if="!item.showSubmenu">
      <v-list-item
         
          name="item.name"
          link
          @click="openSubmenu(item);"
          @mouseover="subMenuDrawer2 = false"
          class="menu-btn"
          v-if="item.meta.isMenuItem && hasPermission(item.meta)"
        >
        <v-list-item-content >
          <v-list-item-title v-if="!mini" class="menu-btn-label d-flex"><!-- justify-start" -->{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </template>
      <template v-else>
        <v-list-item
          v-show="item.meta.isMenuItem && hasPermission(item.meta)"
          :key="item.name"
          name="item.name"
          link
          @mouseover="buildSubMenu(item, {submenuName:'subMenuDrawer2', submenuList:'itemsSubMenu2', level:2})"
          @click="stopMouseOver(item, {level:2});"
          class="menu-btn"
        >
          <v-list-item-content>
              <v-list-item-title v-if="!mini" class="menu-btn-label d-flex" style="font-weight: bold">{{  item.text }}</v-list-item-title>
              <!-- (item.module && item.module!='portal') ? modulosTitles[item.meta.module] : -->
          </v-list-item-content>
        </v-list-item>
      </template>

      </span>
    </v-list>
    
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawer"
      color="secondary"
      fixed
      permanent
      :class="[{ mini: mini }, 'nav-menu']"
    >
    <!-- style="z-index: 9999" -->
      <div class="mt-4 mb-3 px-3" @click="$router.push('/');config()" style="cursor:pointer">
         <!-- @click="mini=!mini" -->
        <v-img src="@/assets/logo.svg" aspect-ratio="1.2" contain v-if="!mini"></v-img>
        <v-img src="@/assets/icon.svg" aspect-ratio="1.7" contain v-if="mini"></v-img>
      </div>
      <template v-if="showMenu">
      <template v-for="item in items" >
        <template v-if="item.children == undefined || !item.children.length">
          <v-list-item
            v-show="item.meta.isMenuItem && hasPermission(item.meta)"
            :key="item.id"
            name="item.name"
            link
            @click="$router.push(item.path).catch(()=>{});config()"
            @mouseover="subMenuDrawer2 = false"
            class="menu-btn"
          >
            <v-list-item-content>
              <div class="d-flex justify-center">
                
                <v-icon color="accent">{{ item.icon }}</v-icon>
              </div>
              <div class="d-flex justify-center">
                <div v-if="!mini" class="menu-btn-label accent--text">{{ (item.meta.module && item.meta.module!='portal' && item.name!='identificacaonaoperadora') ? modulosTitles[item.module] : item.text }}</div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item
            v-show="item.meta.isMenuItem && hasPermission(item.meta)"
            :key="item.name"
            name="item.name"
            link
            @mouseover="buildSubMenu(item, {submenuName:'subMenuDrawer', submenuList:'itemsSubMenu', level:1})"
            @click="stopMouseOver(item, {level:1});config()"
            :to="item.path"
            class="menu-btn"
          >
            <v-list-item-content>
              <div class="d-flex justify-center">
                <v-icon color="accent">{{ item.icon }}</v-icon>
              </div>
              <div class="d-flex justify-center">
                <v-list-item-title v-if="!mini" class="menu-btn-label accent--text">{{  item.text }}</v-list-item-title>
                <!-- (item.module && item.module!='portal') ? modulosTitles[item.meta.module] : -->
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
      </template>
      <template v-slot:append v-if="showMenu">
        <v-list-item
          v-for="item in itemsFooter"
          v-show="hasPermission(item.meta)"
          :key="item.name"
          name="item.name"
          link
          @click="$router.push(item.path).catch(()=>{});config(true)"
          class="menu-btn"
        >
          <v-list-item-content>
            <div class="d-flex justify-center">
              <v-icon color="accent">{{ item.icon }}</v-icon>
            </div>
            <div class="d-flex justify-center">
              <v-list-item-title v-if="!mini" class="menu-btn-label accent--text">{{ item.text }}</v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
      
    </v-navigation-drawer>
  
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex'
// import routes from "../../router/router"
export default {
    props:{
        drawer: Boolean,
        showMenu: Boolean
    },
  data() {
    return {
      activeSubmenu: false,
      stopbuildSubMenu: {1: false, 2: false },
      items: this.$router.options.routes[0].children,
      itemsSubMenu: [],
      itemsSubMenu2: [],
      itemsFooter: this.$router.options.routes[1].children,
      mini: false,
      subMenuDrawer: false,
      subMenuDrawer2: false,
      paramModulos: false
    };
  },
  watch: {
    permissao:{
      deep: true,
      handler(){
        this.$nextTick()
      }
    },
  },
  computed: {
    ...mapState({
      isTradimus: state => state.userData.userData.UsuarioTradimus,
      modulosTitles: state => state.permissions.modulosTitles,
      permissao: state => state.permissions.permissaoBase,
      permissaoUsuario: state => state.userData.userData.PermissaoAcoes,
      grupoEconomico: (state) => state.permissions.grupoEconomico
    })
  },
  methods: {
    config(bool) {
      this.paramModulos = bool ?bool :this.paramModulos
      if (this.paramModulos) {
        setTimeout(() => {
          this.$store.dispatch("permissions/getModulos", {grupoEconomico:this.grupoEconomico}).then(() => {
            if (bool) { this.paramModulos = true }
            else { this.paramModulos = false }
          }
        )}, 50)
      }
    },
    buildSubMenu(item, opts){
      if(this.stopbuildSubMenu[opts.level] && item.name == this.activeSubmenu){ 
        return
      }
      this[opts.submenuName] = false;
      this[opts.submenuList] = item;
      this[opts.submenuName] = true;
      // this.subMenuDrawer = false;
      // this.itemsSubMenu = item;
      // this.subMenuDrawer = true;
    },
    openSubmenu(item) {
      // if(item.name == this.activeSubmenu)
      //   return
      this.$router.push(item.path).catch(()=>{})
      if(this.subMenuDrawer2){
        this.subMenuDrawer2 = !this.subMenuDrawer2;
      }
      this.subMenuDrawer = !this.subMenuDrawer;
    },
    stopMouseOver(item, opts){
      this.stopbuildSubMenu[opts.level] = true
      this.activeSubmenu = item.name
      this.subMenuDrawer = false
      setTimeout(()=> {
        for(let i=1; i<3; i++){
          this.stopbuildSubMenu[i] = false
        }
        this.activeSubmenu = null
      },1200)
    },
    hasPermission(menuItemMeta){
      //this.permissao -> para validar os módulos que o grupo economico tem acesso
      let permissaoList = Object.keys(this.permissao)
      let permissaoUserList = Object.keys(this.permissaoUsuario)
      // let permissao =  this.isTradimus ? this.permissao : this.permissaoUsuario
      let permissao =  this.isTradimus ? permissaoList.filter(x => x == permissaoUserList.find(el => el == x)) : permissaoUserList
      if(!permissao){
        return
      }
      if(menuItemMeta.enabledByPermission) {
        // let accessibleModules = Object.keys(permissao)
        if(menuItemMeta.action == 'getextratofatenvioanexo' && this.grupoEconomico != 1 && this.grupoEconomico != 161) {
             return  false //this.isTradimus? true : false
         }
        let accessibleModules = permissao
        let hasModule = accessibleModules.includes(menuItemMeta.module)
        let hasAction = menuItemMeta.action? false : true
        if(menuItemMeta.module && this.permissaoUsuario[menuItemMeta.module]){
          hasAction = menuItemMeta.action? this.permissaoUsuario[menuItemMeta.module].includes(menuItemMeta.action) : true
        }
        return hasModule && hasAction
      } else {
        return true
      }
    }
  }
}
</script>